
import { toast } from "react-toastify"
import { fetchConToken, fetchConTokenFileExcel } from "../helpers/fetch"

export const Buy = {

    getAll: async (filters) => {
        try {

            const params = (new URLSearchParams(filters)).toString()
            const resp = await fetchConToken(`compras/?${params}`)
            const body = await resp.json()
            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    getOne: async (id) => {
        try {

            const resp = await fetchConToken(`compras/${id}`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    save: async (dataForm) => {
        try {

            const resp = await fetchConToken('compras', dataForm, 'POST')
            const body = await resp.json()

            if (body.ok) {

                toast.success(body.msg)
                return body.data.id

            } else {

                toast.error(body.msg)
                return null

            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    update: async (dataForm) => {
        try {

            const resp = await fetchConToken(`compras/${dataForm.id}`, dataForm, 'PUT')
            const body = await resp.json()

            if (body.ok) {

                toast.success(body.msg)
                return body.data

            } else {

                toast.error(body.msg)
                return null
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    updateAnular: async (dataForm) => {
        try {

            const resp = await fetchConToken(`compras/anular/${dataForm.id}`, dataForm, 'PUT')
            const body = await resp.json()

            if (body.ok) {

                toast.success(body.msg)
                return body.data

            } else {

                toast.error(body.msg)
                return null
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    getCategorias: async () => {
        try {

            const resp = await fetchConToken(`catalog/categorias/all`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    saveCat: async (data) => {
        try {

            const resp = await fetchConToken('catalog/categoria', data, "POST")
            const body = await resp.json();

            if (body.ok) {

                toast.success(body.msg)
                return body.data.id

            } else {

                toast.error(body.msg)
                return null

            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    updateCat: async (data) => {
        try {

            const resp = await fetchConToken(`catalog/categoria/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {

                toast.success(body.msg)
                return body.data

            } else {

                toast.error(body.msg)
                return null
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    deleteCat: async (id) => {
        try {

            const resp = await fetchConToken(`catalog/categoria/delete/${id}`, {}, "PUT")
            const body = await resp.json()

            console.log('body delete--', body)

            if (body.ok) {

                toast.success(body.msg)
                return body.data

            } else {

                toast.error(body.msg)
                return null
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    getExport: async (filters) => {
        try {

            const params = (new URLSearchParams(filters)).toString()
            const fileName = `catalogo_${new Date()}_`
            const resp = await fetchConTokenFileExcel(`catalog/export/excel/?${params}`, {}, 'GET', fileName)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {

                toast.error('Lo sentimos, ocurrió un error')
                return null

            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    getInfoBancaria: async () => {
        try {

            const resp = await fetchConToken('bancos/info-bancaria')
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    }

}